import React from 'react';
import Button from '../../UI/Button/Button';

import classes from './ConfirmPopup.css';
import { LABEL_CANCEL, LABEL_CONFIRM } from '../../shared/Constants';

const ConfirmStopPopUp = (props) => (
    <div className={classes.ConfirmPopupDiv}>
        <strong className={classes.Warning}>Are you sure to STOP the user activity </strong>
        <div className={classes.ButtonDiv}>
            <Button id="cancel" btnType="Cancel" clicked={props.cancelled}>{LABEL_CANCEL}</Button>
            <Button id="confirm" btnType="Search" clicked={props.handleSubmit}>{LABEL_CONFIRM}</Button>
        </div>
    </div>
);

export default ConfirmStopPopUp;